import { render, staticRenderFns } from "./Login_Center2.vue?vue&type=template&id=9458833c&scoped=true&"
import script from "./Login_Center2.vue?vue&type=script&lang=js&"
export * from "./Login_Center2.vue?vue&type=script&lang=js&"
import style0 from "./Login_Center2.vue?vue&type=style&index=0&id=9458833c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9458833c",
  null
  
)

export default component.exports